// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.attendance-lookup-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  margin-top:20px;
}

/* Card Styling */
.attendance-lookup-card {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 30px;
  margin-bottom: 30px;
}

/* Title Styling */
.attendance-lookup-title {
  color: var(--gray-800);
  font-size: 24px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.title-icon {
  margin-right: 12px;
  color: var(--primary-400);
}

/* Form Styling */
.attendance-form {
  margin-bottom: 30px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px 20px;
}

.form-group {
  flex: 1 1;
  min-width: 250px;
  padding: 0 15px;
  margin-bottom: 15px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #34495e;
  font-size: 14px;
}

.input-icon {
  margin-right: 8px;
  color: var(--gray-500);
}

.form-select,
.form-date-input {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s;
  background-color: #f9f9f9;
}

.form-select:focus,
.form-date-input:focus {
  border-color: var(--primary-400);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  outline: none;
  background-color: #fff;
}

.date-picker-wrapper {
  width: 100%;
}

.date-range-row {
  display: flex;
  justify-content: space-between;
}

.date-group {
  flex: 1 1;
  margin-right: 15px;
}

.date-group:last-child {
  margin-right: 0;
}

/* Button Styling */
/* .submit-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  margin-top: 10px;
}

.submit-button:hover {
  background-color: var(--primary-600);
  transform: translateY(-1px);
}

.submit-button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
  transform: none;
} */

.get-attendence-record-submit-button {
  background-color: var(--primary-400);
  color: white;
  border: none;
  padding: 0.875rem 2rem;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  /* min-width: 220px; */
  align-items: center;
  justify-content: center;
  width: 320px;
  margin-left: 400px;
}

.get-attendence-record-submit-button:hover {
  background-color: var(--primary-600);
  transform: translateY(-1px);
}

/* .get-attendence-record-submit-button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
  transform: none;
} */

.button-icon {
  margin-right: 8px;
}

.loading-text {
  display: flex;
  align-items: center;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error Message */
.error-message {
  background-color: #fdecea;
  color: var(--error);
  padding: 12px 15px;
  border-radius: 6px;
  margin: 20px 0;
  font-size: 14px;
}

/* Results Section */
.results-section {
  margin-top: 30px;
}

.results-title {
  color: var(--gray-800);
  font-size: 18px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* Records Grid */
.records-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.record-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
  transition: transform 0.3s, box-shadow 0.3s;
  border-left: 4px solid var(--primary-400);
}

.record-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.record-date {
  font-weight: 600;
  color: var(--primary-400);
  margin-bottom: 15px;
  font-size: 15px;
}

.record-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.detail-icon {
  margin-right: 10px;
  color: var(--gray-500);
  width: 16px;
  text-align: center;
}

.detail-label {
  font-weight: 500;
  color: #34495e;
  margin-right: 8px;
  min-width: 70px;
}

.detail-value {
  color: var(--gray-800);
}

.no-records {
  text-align: center;
  padding: 30px;
  color: var(--gray-500);
  font-size: 16px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .date-range-row {
    flex-direction: column;
  }

  .date-group {
    margin-right: 0;
    margin-bottom: 15px;
  }

  .records-grid {
    grid-template-columns: 1fr;
  }

  .attendance-lookup-card {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .form-group {
    min-width: 100%;
  }

  .get-attendence-record-submit-button {
    width: 100%;
    margin-left: 0px;
  }
}





















/* Add these styles to your existing CSS */
.attendance-summary-single-line {
  margin-bottom: 20px;
}

.summary-data-bold {
  font-size: 16px;
  margin-top: 5px;
}

.records-list-single-line {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.record-single-line {
  background-color: var(--gray-50);
  padding: 12px;
  border-radius: 4px;
}

.record-data-bold {
  margin: 0;
  font-size: 14px;
}

/* Make sure strong tags are properly styled */
strong {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/Attendence/AdminAttendanceLookup.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;;;GAIG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;;;;;;;;;;;;;;;;;;;;;AAsBA,0CAA0C;AAC1C;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;AAClB","sourcesContent":["/* Main Container */\n.attendance-lookup-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  margin-top:20px;\n}\n\n/* Card Styling */\n.attendance-lookup-card {\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  padding: 30px;\n  margin-bottom: 30px;\n}\n\n/* Title Styling */\n.attendance-lookup-title {\n  color: var(--gray-800);\n  font-size: 24px;\n  margin-bottom: 25px;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.title-icon {\n  margin-right: 12px;\n  color: var(--primary-400);\n}\n\n/* Form Styling */\n.attendance-form {\n  margin-bottom: 30px;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 -15px 20px;\n}\n\n.form-group {\n  flex: 1;\n  min-width: 250px;\n  padding: 0 15px;\n  margin-bottom: 15px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #34495e;\n  font-size: 14px;\n}\n\n.input-icon {\n  margin-right: 8px;\n  color: var(--gray-500);\n}\n\n.form-select,\n.form-date-input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid var(--gray-200);\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.3s;\n  background-color: #f9f9f9;\n}\n\n.form-select:focus,\n.form-date-input:focus {\n  border-color: var(--primary-400);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n  outline: none;\n  background-color: #fff;\n}\n\n.date-picker-wrapper {\n  width: 100%;\n}\n\n.date-range-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.date-group {\n  flex: 1;\n  margin-right: 15px;\n}\n\n.date-group:last-child {\n  margin-right: 0;\n}\n\n/* Button Styling */\n/* .submit-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 200px;\n  margin-top: 10px;\n}\n\n.submit-button:hover {\n  background-color: var(--primary-600);\n  transform: translateY(-1px);\n}\n\n.submit-button:disabled {\n  background-color: #bdc3c7;\n  cursor: not-allowed;\n  transform: none;\n} */\n\n.get-attendence-record-submit-button {\n  background-color: var(--primary-400);\n  color: white;\n  border: none;\n  padding: 0.875rem 2rem;\n  font-size: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  /* min-width: 220px; */\n  align-items: center;\n  justify-content: center;\n  width: 320px;\n  margin-left: 400px;\n}\n\n.get-attendence-record-submit-button:hover {\n  background-color: var(--primary-600);\n  transform: translateY(-1px);\n}\n\n/* .get-attendence-record-submit-button:disabled {\n  background-color: #bdc3c7;\n  cursor: not-allowed;\n  transform: none;\n} */\n\n.button-icon {\n  margin-right: 8px;\n}\n\n.loading-text {\n  display: flex;\n  align-items: center;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s ease-in-out infinite;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error Message */\n.error-message {\n  background-color: #fdecea;\n  color: var(--error);\n  padding: 12px 15px;\n  border-radius: 6px;\n  margin: 20px 0;\n  font-size: 14px;\n}\n\n/* Results Section */\n.results-section {\n  margin-top: 30px;\n}\n\n.results-title {\n  color: var(--gray-800);\n  font-size: 18px;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n/* Records Grid */\n.records-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.record-card {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 20px;\n  transition: transform 0.3s, box-shadow 0.3s;\n  border-left: 4px solid var(--primary-400);\n}\n\n.record-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.record-date {\n  font-weight: 600;\n  color: var(--primary-400);\n  margin-bottom: 15px;\n  font-size: 15px;\n}\n\n.record-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-row {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.detail-icon {\n  margin-right: 10px;\n  color: var(--gray-500);\n  width: 16px;\n  text-align: center;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #34495e;\n  margin-right: 8px;\n  min-width: 70px;\n}\n\n.detail-value {\n  color: var(--gray-800);\n}\n\n.no-records {\n  text-align: center;\n  padding: 30px;\n  color: var(--gray-500);\n  font-size: 16px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .date-range-row {\n    flex-direction: column;\n  }\n\n  .date-group {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n\n  .records-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .attendance-lookup-card {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-group {\n    min-width: 100%;\n  }\n\n  .get-attendence-record-submit-button {\n    width: 100%;\n    margin-left: 0px;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Add these styles to your existing CSS */\n.attendance-summary-single-line {\n  margin-bottom: 20px;\n}\n\n.summary-data-bold {\n  font-size: 16px;\n  margin-top: 5px;\n}\n\n.records-list-single-line {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.record-single-line {\n  background-color: var(--gray-50);\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.record-data-bold {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Make sure strong tags are properly styled */\nstrong {\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
